import React from 'react'
import {
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import ActionButton from '@dhn/components/molecules/action-button'
import ModalHeader from '@dhn/components/molecules/modal-header'
import PasswordInput from '@dhn/components/molecules/password-input'
import SectionHeader from '@dhn/components/molecules/section-header'

export default function SecurityModal({ state, isOpen, toggle, onChange, onModifiyPassword, username }) {
  const close = state.saving ? undefined : toggle

  const onSubmit = (event) => {
    event.preventDefault()
    onModifiyPassword()
  }

  return (
    <Modal isOpen={isOpen} toggle={close} centered backdrop='static'>
      {/* El <form> y el usuario en solo lectura limitan el autocompletado del
          navegador a este modal; sin ellos rellena campos de la pantalla de fondo. */}
      <Form onSubmit={onSubmit}>
        <ModalHeader
          toggle={close}
          iconClass='fa-shield'
          description='Seguridad'
          subtitle='Modifique la contraseña de acceso de su usuario.'
        />
        <ModalBody>
          <SectionHeader
            compact
            icon='fa-key'
            title='Cambiar contraseña'
            description='Mínimo 6 caracteres, con al menos una letra mayúscula y un carácter especial.'
          />

          <FormGroup>
            <Label for='navbar-config-user'>Usuario</Label>
            <Input
              id='navbar-config-user'
              name='username'
              autoComplete='username'
              value={username || ''}
              readOnly
            />
          </FormGroup>

          <FormGroup>
            <Label for='navbar-config-current-password'>Contraseña actual</Label>
            <PasswordInput
              id='navbar-config-current-password'
              name='current-password'
              placeholder='Escribir contraseña actual'
              autoComplete='current-password'
              value={state.currentPassword}
              onChange={(e) => onChange('currentPassword', e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label for='navbar-config-new-password'>Nueva contraseña</Label>
            <PasswordInput
              id='navbar-config-new-password'
              name='new-password'
              placeholder='Escribir nueva contraseña'
              autoComplete='new-password'
              invalid={state.differentInputPassword}
              value={state.newPassword}
              onChange={(e) => onChange('newPassword', e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label for='navbar-config-confirm-password'>Confirmar contraseña</Label>
            <PasswordInput
              id='navbar-config-confirm-password'
              name='confirm-password'
              placeholder='Confirmar nueva contraseña'
              autoComplete='new-password'
              invalid={state.differentInputPassword}
              value={state.confirmPassword}
              onChange={(e) => onChange('confirmPassword', e.target.value)}
            >
              <FormFeedback>
                Las contraseñas deben coincidir y cumplir los requisitos.
              </FormFeedback>
            </PasswordInput>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <ActionButton
            action='modify'
            type='submit'
            label={state.saving ? 'Guardando...' : 'Modificar'}
            isLoading={state.saving}
            disabled={state.saving}
          />
          <ActionButton
            action='cancel'
            disabled={state.saving}
            onClick={toggle}
          />
        </ModalFooter>
      </Form>
    </Modal>
  )
}
